import React from 'react';
import cx from 'classnames';

import { MirrorService } from 'services/MirrorService';

import styles from './desktopPageWrapper.module.sass';

interface Props {
  withoutBottomPadding?: boolean;
  withoutBigTopPadding?: boolean;
}

export const DesktopPageWrapper: React.FC<Props> = ({
  children,
  withoutBottomPadding = false,
  withoutBigTopPadding = false,
}) => {
  return (
    <div
      className={cx(styles.wrapper, {
        [styles.sweatHeartSoul]: MirrorService.isSweatHeartSoul,
        [styles.bottomPadding0]: withoutBottomPadding,
        [styles.topPadding20]: withoutBigTopPadding,
      })}
    >
      {children}
    </div>
  );
};
